/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Billing page components
import Invoice from "./components/Invoice";
import BaseLayout from "../components/BaseLayout";
import { useApiClient } from "common/ApiClientProvider";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import ROUTE_PATHS from "routePaths";

function Invoices() {
  const { t } = useTranslation("pages");
  const { getUser } = useKindeAuth();
  const apiClient = useApiClient();
  const user = getUser();
  const [userBills, setUserBills] = useState({
    results: [],
  });
  const navigate = useNavigate();
  async function getUserBill(userBillUrl) {
    await apiClient.post("current_customer", {
      body: { email: user.email },
    });
    /*
    const params = {
      customer_id: customer.id,
    };
    if (startingAfter) {
      params.starting_after = startingAfter;
    }
    if (endingBefore) {
      params.ending_before = endingBefore;
    }
    */
    const userBills = await apiClient.get(userBillUrl);
    setUserBills(userBills);
  }
  useEffect(() => {
    getUserBill("user_bill/");
  }, []);
  return (
    <BaseLayout stickyNavbar>
      <MDBox mt={4}>
        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card sx={{ height: "100%" }}>
                <MDBox
                  pt={2}
                  px={2}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <MDTypography variant="h6" fontWeight="medium">
                    {t("account.invoices")}
                  </MDTypography>
                  <MDBox display="flex" gap={1}>
                    {userBills.previous && (
                      <MDButton
                        variant="outlined"
                        color="info"
                        size="small"
                        onClick={() => getUserBill(userBills.previous)}
                      >
                        {t("account.previousPage")}
                      </MDButton>
                    )}
                    {userBills.next && (
                      <MDButton
                        variant="outlined"
                        color="info"
                        size="small"
                        onClick={() => getUserBill(userBills.next)}
                      >
                        {t("account.nextPage")}
                      </MDButton>
                    )}
                  </MDBox>
                </MDBox>
                <MDBox p={2}>
                  <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
                    {userBills.results.map((result) => (
                      <Invoice
                        key={`${result.id}`}
                        date={`${result.year}-${result.month}`}
                        id=""
                        price={`${result.total_amount / 100}`}
                        onClick={() => {
                          navigate(ROUTE_PATHS.accountInvoiceDetail, {
                            state: { id: result.id },
                          });
                        }}
                      />
                    ))}
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </BaseLayout>
  );
}

export default Invoices;
